import i18n from 'utils/i18n'
import type { GenericFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  SWITCHER,
  NUMBER,
  COUNTRIES_LIST,
  offersFiltersTitle,
  offersFiltersName,
  offersFiltersKey,
  EMAIL_STATUS_LIST,
} from 'utils/consts'

export const getAdministrationRequestsPotentialProducersFiltersCollection =
  () => [
    {
      type: filterTypes[COUNTRIES_LIST],
      title: i18n.t(offersFiltersTitle.producerCountryFilter),
      filterName: offersFiltersName.producerCountryFilter,
      apiFilterName: offersFiltersKey().producerCountry,
    },
    {
      type: filterTypes[SWITCHER],
      title: i18n.t(offersFiltersTitle.withEmailFilter),
      filterName: offersFiltersName.withEmailFilter,
      apiFilterName: offersFiltersKey().withEmailFilter,
      nonFacetFilter: true,
    },
    {
      type: filterTypes[NUMBER],
      title: i18n.t(offersFiltersTitle.daysSinceLastNewsletterFilter),
      filterName: offersFiltersName.daysSinceLastNewsletterFilter,
      apiFilterName: offersFiltersKey().daysSinceLastNewsletterFilter,
      label: 'filters.days',
      nonFacetFilter: true,
    },
    {
      type: filterTypes[EMAIL_STATUS_LIST],
      title: i18n.t(offersFiltersTitle.emailStatusFilter),
      filterName: offersFiltersName.emailStatusFilter,
      apiFilterName: offersFiltersKey().emailStatus,
    },
  ]

export const adminPotentialProducersFiltersConfig: GenericFiltersConfig = {
  getFiltersCollection: getAdministrationRequestsPotentialProducersFiltersCollection,
  pathToStore: ['offers'],
  filtersDataPath: ['wineOfferRequest', 'matches', 'tradeNamesPagination', 'pageInfo'],
  showResultsTextKey: 'filters.button.apply',
  showPresets: false,
}
